<!-- Duplicate Laptop Card with Input Field (without text)-->
<ng-template #duplicateProfile id="duplicateProfileMainDiv">
  <div class="card duplicate_laptop" dir={{direction}} id="cardDuplicateLaptop">
    <div _ngcontent-fjy-c198="" class="close" (click)="close()" id="duplicateClose">
      <img _ngcontent-fjy-c198="" alt="close" class="modal-close-icon">
    </div>
    <div class="popup-body" id="duplicatePopupBody">
      <h2 class="form_header">{{duplicateHead}} {{profileName}}</h2>
      <label><span [innerHTML]="profName"></span><span class="text-danger">*</span></label>
      <input type="text" (input)="checkDuplicateProfileName($event)" class="form-control" [(ngModel)]="newProfileName" placeholder={{profName}} />
      <span class="text-danger" *ngIf = "specialChar">Special characters such as < . , * < > " | \ : > are not allowed to name a profile</span>
      <div *ngIf="isDuplicateProfileNameValid" class="formfield_err_msg" [innerHTML]='profileNameValidationMsg' id="duplicateProfileErrMsg">
      </div>
      <div class="card-footer" id="duplicateCardFooter">
        <button type="button" class="btn btn-outline-primary gtmDuplicateCancel cancel-btn" [innerHTML]="cancel" (click)="close()"></button>
        <button type="button" class="btn btn-primary gtmDuplicateProfile delete-btn" [innerHTML]="duplicateProfileBtn"
          (click)="createDuplicateProfile(newProfileName)" [disabled]='!newProfileName?.trim()?.length'></button>
      </div>
    </div>
  </div>
</ng-template>